import { debounce, throttle } from 'lodash';
import { useEffect } from 'react';

export default function useInfiniteScroll(loadData, layoutMarginBottom = 60) {
  useEffect(() => {
    const onScroll = throttle(() => {

      const distanceScrolled = window.scrollY;
      const screenHeight = window.innerHeight;
      const footerHeight = document.querySelector('footer').offsetHeight;
      const documentHeight = document.documentElement.scrollHeight;

      const isUserNearTheBottom = (distanceScrolled + screenHeight + footerHeight + layoutMarginBottom) >= documentHeight;

      if (isUserNearTheBottom) loadData();

    }, 300);

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [layoutMarginBottom, loadData]);

}

export function useInfiniteScrollTop(loadData, offset = 54) {
  useEffect(() => {
    const onScroll = debounce(() => {
      if (window.scrollY <= offset) loadData();
    }, 300);

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [offset, loadData]);

}
